<template>
  <div class="mobilesummarydetail">
    <div class="detail_wrapper">
      <div class="detail_title">{{$route.query.name.indexOf('接口')>-1 ? $route.query.name.replace("接口",""):$route.query.name }}接口调用统计</div>
      <div style="margin-top:15px;">
        <el-table
          :data="tableData"
          class="content_table"
          :height="height">
          <el-table-column
            align="center"
            prop="localDate"
            width="150px">
            <template slot="header" slot-scope="scope">
              <el-date-picker
                v-model="pickDate"
                :editable=false
                :popper-class="'header-date-popper'"
                :prefix-icon="isOpen?'el-icon-caret-bottom':'el-icon-caret-top'"
                type="month"
                class="header-date"
                :clearable=false
                @change="detailService()"
                placeholder="选择日期"
                format="yyyy-MM"
                value-format="yyyy-MM">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            label="API调用（次）"
            align="center"
            prop="apiCount"
            width="150px">
          </el-table-column>
          <el-table-column
            label="总调用（道）"
            align="center"
            prop="detailCount"
            width="150px">
          </el-table-column>
          <el-table-column
            label="去重调用（道）"
            align="center"
            prop="distinctCount"
            width="150px">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import detailService from '@/service/front/detailService'
export default {
  data () {
    return {
      height: this.SysConstant.winHeight - 100,
      details: {},
      pickDate: '',
      tableData: [],
      isOpen: true
    }
  },
  name: 'mobilesummarydetail',
  watch: {
    $route (from, to) {
      this.detailService()
    }
  },
  async mounted () {
    this.pickDate = new Date().Format('yyyy-MM')
    await this.detailService()
  },
  methods: {
    async detailService () {
      try {
        let param = this.pickDate
        let data = await detailService.fetchSummary(param)
        if (data) {
          let _datas = []
          if (this.$route.query.name === '通用接口') {
            if (data && data.commonCount && data.commonCount.itemList) {
              for (let item of data.commonCount.itemList) {
                _datas.push({
                  localDate: item.localDate,
                  apiCount: item.count,
                  detailCount: '-',
                  distinctCount: ''
                })
              };
            }
          } else if (this.$route.query.name === '试题库') {
            // 总调用
            let questionDetailCount = {}
            if (data && data.questionDetailCount && data.questionDetailCount.itemList) {
              for (let item of data.questionDetailCount.itemList) {
                questionDetailCount[item.localDate] = item.count
              };
            }
            // 去重调用
            let questionDetailDistinctCount = {}
            if (data && data.questionDetailDistinctCount && data.questionDetailDistinctCount.itemList) {
              for (let item of data.questionDetailDistinctCount.itemList) {
                questionDetailDistinctCount[item.localDate] = item.count
              };
            }
            if (data && data.questionCount && data.questionCount.itemList) {
              for (let item of data.questionCount.itemList) {
                _datas.push({
                  localDate: item.localDate,
                  apiCount: item.count,
                  detailCount: questionDetailCount[item.localDate],
                  distinctCount: questionDetailDistinctCount[item.localDate]
                })
              };
            }
          } else if (this.$route.query.name === '文档资源库') {
            // 总调用
            let documentDownloadCount = {}
            if (data && data.documentDownloadCount && data.documentDownloadCount.itemList) {
              for (let item of data.documentDownloadCount.itemList) {
                documentDownloadCount[item.localDate] = item.count
              };
            }
            // 去重调用
            let documentDownloadDistinctCount = {}
            if (data && data.documentDownloadDistinctCount && data.documentDownloadDistinctCount.itemList) {
              for (let item of data.documentDownloadDistinctCount.itemList) {
                documentDownloadDistinctCount[item.localDate] = item.count
              };
            }
            if (data && data.documentCount && data.documentCount.itemList) {
              for (let item of data.documentCount.itemList) {
                _datas.push({
                  localDate: item.localDate,
                  apiCount: item.count,
                  detailCount: documentDownloadCount[item.localDate],
                  distinctCount: documentDownloadDistinctCount[item.localDate]
                })
              };
            }
          } else if (this.$route.query.name === '名校接口') {
            // 总调用
            let documentDownloadCount = {}
            if (data && data.documentDownloadCount && data.eliteSchoolDocumentDownloadCount.itemList) {
              for (let item of data.eliteSchoolDocumentDownloadCount.itemList) {
                documentDownloadCount[item.localDate] = item.count
              };
            }
            // 去重调用
            let documentDownloadDistinctCount = {}
            if (data && data.documentDownloadDistinctCount && data.eliteSchoolDocumentDistinctCount.itemList) {
              for (let item of data.eliteSchoolDocumentDistinctCount.itemList) {
                documentDownloadDistinctCount[item.localDate] = item.count
              };
            }
            if (data && data.documentCount && data.eliteSchoolDocumentCount.itemList) {
              for (let item of data.eliteSchoolDocumentCount.itemList) {
                _datas.push({
                  localDate: item.localDate,
                  apiCount: item.count,
                  detailCount: documentDownloadCount[item.localDate],
                  distinctCount: documentDownloadDistinctCount[item.localDate]
                })
              };
            }
          }
          this.tableData = _datas
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error({
          message: e && e.msg,
          customClass: 'errmsg'
        })
      }
    }
  }
}
</script>
<style scoped>
  .mobilesummarydetail{
    height: 100%;
    width: 100%;
  }
  .mobilesummarydetail .detail_wrapper{
    height: 100%;
    width: 100%;
    padding: 20px 15px;
  }
  .mobilesummarydetail .detail_wrapper .detail_title{
    font-size:16px;
    font-weight:bold;
    color: #333333;
  }
  .mobilesummarydetail .detail_item{
    margin-bottom: 10px;
  }
  .mobilesummarydetail .detail_item .detail_label{
    color: #333333;
    font-size:16px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
  }
  .mobilesummarydetail .detail_item .detail_value{
     color: #666666;
    font-size:16px;
    font-family:MicrosoftYaHei;
    font-weight: normal;
    margin-right: 20px;
  }

  .mobilesummarydetail .layout_table{
    background:#F7F7F7;
    border:1px solid #E2E2E2;
    border-radius:4px;
    margin-top: 15px;
  }
  .mobilesummarydetail .layout_table .el-table__body-wrapper{
    background-color: #E6E6E6;
  }
  .mobilesummarydetail .layout_table .content_table{
    margin: 16px;
  }

</style>
<style type="text/css">

  .mobilesummarydetail .layout_table .content_table td,
  .mobilesummarydetail .layout_table .content_table th{
    border-width: 0px;
    color: #333333;
  }
  .mobilesummarydetail .layout_table .el-table td,
  .mobilesummarydetail .layout_table .el-table th.is-leaf{
    border-width: 0px;
  }
  /* .summarydetail .layout_table .el-table--enable-row-hover .el-table__body tr:hover>td,
  .summarydetail .layout_table .el-table th,
  .summarydetail .layout_table .el-table th div,
  .summarydetail .layout_table .el-table td,
  .summarydetail .layout_table .el-table td div,
  .summarydetail .layout_table .el-table tr{
    background: #F7F7F7;
  } */

  .mobilesummarydetail .layout_table .el-table .el-table__header th{
    font-weight: bold;
  }

  .mobilesummarydetail .el-table__body-wrapper.is-scrolling-none{
    background-color: #F7F7F7;
  }
  .mobilesummarydetail .header-date .el-input__inner{
    border-color: transparent;
    background-color: transparent;
    font-size:14px;
    font-family:MicrosoftYaHei;
    font-weight:600;
    color:#333333;
    width: 124px;
  }
  .mobilesummarydetail .header-date .el-input__prefix{
    font-size: 18px;
    color: #333333;
    right: -5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/mobiledeveloper/summary/index.vue